import { JSX }	from "preact";

import { Endo }	from "ts-base/endo";

import {
	MeetingGeneralModel,
	MeetingPhoneModel,
	FormState,
} from "@geotoura/floater/model";
import { useMessages }	from "@geotoura/floater/useMessages";
import { Error }		from "@geotoura/floater/Error";
import { Success }		from "@geotoura/floater/Success";
import { MeetingOld }	from "@geotoura/floater/MeetingOld";
import { MeetingNew }	from "@geotoura/floater/MeetingNew";

export type MeetingProps	= Readonly<{
	data: {
		general:	MeetingGeneralModel,
		phone:		MeetingPhoneModel,
	},
	state:	FormState,
	modifyGeneral:	(change:Endo<MeetingGeneralModel>) => void,
	modifyPhone:	(change:Endo<MeetingPhoneModel>) => void,
}>;

export const Meeting = ({ data, state, modifyGeneral, modifyPhone }:MeetingProps):JSX.Element => {
	const msg			= useMessages();

	return (
		<div class="floater-dialog meeting">
			{ state === "error"	&&
				<Error/>
			}
			{ state === "ok"	&&
				<Success conversionType="conversion-meeting"/>
			}
			{ state === "form"	&& msg.meeting.booking.href !== "" &&
				<MeetingNew
					data={data}
					modifyGeneral={modifyGeneral}
				/>
			}
			{ state === "form"	&& msg.meeting.booking.href === "" &&
				<MeetingOld
					data={data}
					modifyGeneral={modifyGeneral}
					modifyPhone={modifyPhone}
				/>
			}
		</div>
	);
};
